export class Matricula {
  constructor(delegacion) {
    this.documento = {
      fecha: '',
      numero: '',
      tipo: 1
    };
    this.solicitud = null;
    this.delegacion = delegacion;
    this.generar_boleta = false;
    this.tipo = 'TECA';
  }
}



// WEBPACK FOOTER //
// ./src/model/Matricula.js